export const franchisesCollectionGuard = 'GET /v2/franchises';
export const franchisesResourceGuard = 'GET /v2/franchises/d+';

export const createFranchisesResourceGuard = 'POST /v2/franchises';
export const updateFranchisesResourceGuard = 'PUT /v2/franchises/d+';
export const deleteFranchisesGuard = 'DELETE /v2/franchises/d+';
